var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("input", {
      staticClass: "input",
      attrs: { type: "checkbox", id: _vm.filterValue },
      domProps: {
        value: _vm.filterValue,
        checked: _vm.isSelected && !_vm.clearSelectedFilters,
      },
      on: {
        change: _vm.handleChange,
        focus: function ($event) {
          _vm.isFocused = true
        },
        blur: function ($event) {
          _vm.isFocused = false
        },
      },
    }),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "label-wrapper", attrs: { for: _vm.filterValue } },
      [
        _c(
          "div",
          { class: [{ iconWrapperFocused: _vm.isFocused }, "icon-wrapper"] },
          [
            _c(
              "icon-base",
              {
                class: [{ iconFocused: _vm.isFocused }, "icon"],
                attrs: {
                  iconName: _vm.filterValue,
                  id: _vm.filterValue + "-icon",
                  iconColor:
                    _vm.filterValue === "Alcohol" ? "white" : "currentColor",
                },
              },
              [
                _c(_vm.icon, {
                  tag: "component",
                  attrs: { strokeColor: _vm.strokeColor },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class:
              _vm.isSelected && !_vm.clearSelectedFilters
                ? "filter-label-selected"
                : "filter-label",
          },
          [
            _vm._v("\n\t\t\t" + _vm._s(_vm.label) + "\n\t\t\t"),
            _vm.isSelected && !_vm.clearSelectedFilters
              ? _c("i", {
                  staticClass: "far fa-times-circle clear-filter",
                  attrs: { title: "Click to clear " + _vm.label + " filter." },
                })
              : _vm._e(),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }